module.exports = __webpack_public_path__ + "static/media/man.891da7b2.jpg";